import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { initials } from '@/lib/format'

const TONES = [
    'bg-primary-soft text-primary-deep',
    'bg-navy text-white',
    'bg-success-soft text-success-strong',
    'bg-warning-soft text-warning-strong',
    'bg-secondary text-navy'
]

const SIZES = {
    xs: 'size-6 text-[10px]',
    sm: 'size-8 text-caption',
    md: 'size-10 text-small',
    lg: 'size-14 text-body',
    xl: 'size-20 text-h2'
}

interface AvatarProps {
    name: string
    tone?: number
    size?: keyof typeof SIZES
    className?: string
}

export const Avatar: FC<AvatarProps> = ({
    name,
    tone = 0,
    size = 'md',
    className
}): ReactNode => {
    return (
        <span
            className={cn(
                'inline-flex shrink-0 select-none items-center justify-center rounded-full font-bold ring-2 ring-card',
                TONES[tone % TONES.length],
                SIZES[size],
                className
            )}
            aria-hidden='true'
        >
            {initials(name)}
        </span>
    )
}
